"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _camelToTitleCase = _interopRequireDefault(require("../camelToTitleCase"));
var _OutputFactory = _interopRequireDefault(require("../OutputFactory"));
var _Search = _interopRequireDefault(require("./Search"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Progress = _interopRequireDefault(require("../Progress"));
var _excluded = ["type"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/index.js";
var fields = {};
var defaultProps = {
  fields: fields,
  limit: 10
};
function OutputTable(_ref) {
  var _this = this;
  var collection = _ref.collection,
    fields = _ref.fields,
    limit = _ref.limit,
    onItemClick = _ref.onItemClick,
    find = _ref.find;
  var _React$useState = _react["default"].useState([]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    objects = _React$useState2[0],
    setObjects = _React$useState2[1];
  var _React$useState3 = _react["default"].useState([]),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    selectedObjects = _React$useState4[0],
    setSelectedObjects = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(true),
    _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
    progress = _React$useState6[0],
    setProgress = _React$useState6[1];
  var _React$useState7 = _react["default"].useState(1),
    _React$useState8 = (0, _slicedToArray2["default"])(_React$useState7, 2),
    current = _React$useState8[0],
    setCurrent = _React$useState8[1];
  var _React$useState9 = _react["default"].useState(false),
    _React$useState10 = (0, _slicedToArray2["default"])(_React$useState9, 2),
    hasMore = _React$useState10[0],
    setMore = _React$useState10[1];
  function getData() {
    var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var skip = (current - 1) * limit;
    var query = {
      count: true,
      limit: limit,
      skip: skip,
      where: where,
      include: ['all'],
      sort: {
        createdAt: -1
      }
    };
    setProgress(true);
    find.execute(collection, query).then(function (_ref2) {
      var count = _ref2.count,
        objects = _ref2.objects;
      setObjects(objects);
      setMore(count > objects.length);
      setProgress(false);
    })["catch"](function (error) {
      setProgress(false);
    });
  }
  _react["default"].useEffect(function () {
    getData();
  }, []);
  function onSelectAll(checked) {
    if (checked) {
      setSelectedObjects((0, _toConsumableArray2["default"])(objects));
    } else {
      setSelectedObjects([]);
    }
  }
  function onSelect(index) {
    var selected = objects[index];
    var i = selectedObjects.indexOf(selected);
    if (i > -1) {
      selectedObjects.splice(i, 1);
    } else {
      selectedObjects.push(selected);
    }
    setSelectedObjects((0, _toConsumableArray2["default"])(selectedObjects));
  }
  function searchSubmit(where) {
    setObjects([]);
    setCurrent(1);
    setMore(false);
    setProgress(true);
    getData(where);
  }
  function next() {
    if (!progress) {
      console.log('next');
      setProgress(true);
      setMore(false);
      setCurrent(current + 1);
      getData();
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-class",
    loadMore: next,
    hasMore: hasMore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    className: "mb-3",
    onSubmit: searchSubmit.bind(this),
    fields: fields,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-responsive shadow-sm mb-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "table table-striped",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    className: "table-dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("th", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    className: "align-middle",
    id: "check_all",
    checked: objects.length === selectedObjects.length && objects.length !== 0,
    onChange: function onChange(checked) {
      return onSelectAll(checked);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 29
    }
  })), Object.keys(fields).map(function (field) {
    var _fields$field = fields[field],
      type = _fields$field.type,
      options = (0, _objectWithoutProperties2["default"])(_fields$field, _excluded);
    if (options.hasOwnProperty('read') && !options.read) return null;
    var label = options.label || (0, _camelToTitleCase["default"])(field);
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: field,
      className: "fs-xs align-middle text-nowrap",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110,
        columnNumber: 33
      }
    }, label);
  }))), /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "bg-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 21
    }
  }, objects.length === 0 && !progress && /*#__PURE__*/_react["default"].createElement("tr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center fs-lg",
    colSpan: Object.keys(fields).length + 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 33
    }
  }, "No Data Found")), objects.map(function (object, index) {
    var id = object.id;
    var checked = selectedObjects.includes(object);
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: id,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 33
      }
    }, /*#__PURE__*/_react["default"].createElement("th", {
      className: "align-middle",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 37
      }
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: checked,
      id: 'check_' + id,
      onChange: function onChange() {
        return onSelect(index);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 41
      }
    })), Object.keys(fields).map(function (field, i) {
      var options = fields[field];
      if (options.hasOwnProperty('read') && !options.read) return null;
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: field,
        className: "fs-sm text-truncate",
        style: {
          cursor: 'pointer',
          maxWidth: '15em'
        },
        onClick: function onClick() {
          return onItemClick(index, field);
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 142,
          columnNumber: 45
        }
      }, /*#__PURE__*/_react["default"].createElement(_OutputFactory["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 149,
          columnNumber: 49
        }
      })));
    }));
  }), progress && /*#__PURE__*/_react["default"].createElement("tr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement("td", {
    colSpan: Object.keys(fields).length + 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 33
    }
  }, /*#__PURE__*/_react["default"].createElement(_Progress["default"], {
    className: "fs-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 78
    }
  }, "Loading ...")))))));
}
OutputTable.defaultProps = defaultProps;
var _default = OutputTable;
exports["default"] = _default;